import { IvrTypificationTemplateTypeEnum } from '../../../shared/types/ivrTypificationBase';

/** Opciones compartidas: import (modal) y filtros; valores = enum del backend */
export const TYPIFICATION_TYPE_OPTIONS = [
    {
        id: IvrTypificationTemplateTypeEnum.SERVICE_CODES,
        name: 'CODIFICACION SERVICIO',
    },
    {
        id: IvrTypificationTemplateTypeEnum.COMMERCIAL,
        name: 'COMERCIAL',
    },
    {
        id: IvrTypificationTemplateTypeEnum.CHILD_SUB_TYPIFICATION,
        name: 'SUBTIPIFICACIONHIJA',
    },
];
